module.exports = __webpack_public_path__ + "img/resized-APP-0018-1.238afd98.png";